import { useCallback, useMemo } from 'react';
import 'react-native-get-random-values'; // IMPORTANT: For react native, we need react-native-get-random-values to be imported before nanoid.
import { nanoid } from 'nanoid';

// TODO: : Add the following lines somewhere in docs
//==========================
// TODO: requires installing nanoid - NOTE: Not 100% sure if we need that.
// TODO: nanoID had an issue with Android, needed react-native-get-random-values implemneted before.
//==========================
// TODO: Anas: Let`s move this to a separate hook instead of having it as part of util-hooks. Also make sure to move docs and FlatListExample.tsx

// TODO: Add to docs some descriptions and examples as well as explanation for where it`s actually used.

interface MB_InfinitePaginationPage<T> {
  items: T[];
  nextOffset?: string | null;
}

interface MB_InfiniteFetchInfiniteData<T = unknown> {
  pages: T[];
  pageParams: unknown[];
}

interface MB_InfiniteFetchQueryHookProps<T extends unknown> {
  data: MB_InfiniteFetchInfiniteData<MB_InfinitePaginationPage<T>> | undefined;
  fetchNextPage: () => void;
  hasNextPage?: boolean;
  isFetching: boolean;
  isLoading: boolean;
}

interface MB_UseInfiniteFetchOptions {
  prefillWhileLoading?: boolean;
  prefillWhileLoadingAmmount?: number;
}

// Note: queryHook used to be UseInfiniteQueryResult<MB_InfinitePaginationPage<T>, ServerError> before but we were having some issues with types when using it with this inside projects
const useMBInfiniteFetch = <T extends any, Options extends MB_UseInfiniteFetchOptions>(queryHook: MB_InfiniteFetchQueryHookProps<T>, options: Options) => {
  const { data: incomingData, fetchNextPage, hasNextPage, isFetching, isLoading } = queryHook;

  const loadMore = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [isFetching, hasNextPage, fetchNextPage]);

  const data: (T | string)[] = useMemo(() => {
    if (options.prefillWhileLoading && isLoading) {
      return Array.from({ length: options.prefillWhileLoadingAmmount ?? 6 }, () => `useMBInfiniteFetchPrefillId_${nanoid()}`);
    }

    if (!incomingData) {
      return [];
    }

    return incomingData.pages.map(page => page.items).flat();
  }, [incomingData, isLoading, options.prefillWhileLoading, options.prefillWhileLoadingAmmount]);

  return { data, loadMore, isLoading, isFetching };
};

export { useMBInfiniteFetch };
export type { MB_UseInfiniteFetchOptions, MB_InfinitePaginationPage, MB_InfiniteFetchQueryHookProps, MB_InfiniteFetchInfiniteData };
